import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div>
          <Logo />
          <p>Roblox Studio skills, taught one working system at a time.</p>
        </div>
        <div className="footer-links">
          <a href="/#curriculum">Curriculum</a>
          <a href="/#plans">Plans</a>
          <a href="/#faq">FAQ</a>
          <Link to="/login">Student login</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} ForgeCode Academy</span>
        <span>Independent course. Not affiliated with Roblox Corporation.</span>
      </div>
    </footer>
  );
}
